<template>
    <fade-transition>
        <a
            @click.prevent="onClick"
        >
            <header-logo-icon/>
            <header-logo-text/>
        </a>
    </fade-transition>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
    computed: {
        ...mapGetters('ui', {
            'isMobile': 'isMobile',
        }),
        ...mapState({
            back: state => state.player.back,
        }),
    },
    methods: {
        onClick() {
            if (this.isMobile) {
                this.$router.push({name: 'home'})
            } else {
                //console.log('back: ', this.back)
                this.$router.push({path: this.back || '/'})
            }
        }
    }
}
</script>
